import { render } from "./FAQPage.vue?vue&type=template&id=7a48d5a4"
import script from "./FAQPage.vue?vue&type=script&lang=js"
export * from "./FAQPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__